module.exports = __webpack_public_path__ + "img/ESP.d5386cda.svg";